import { useCallback } from 'react';
import { option } from 'fp-ts';

import { useCatalogContext } from 'modules/catalog/catalogSelector/catalogContext';

export const useValidateCatalogSelectors = () => {
  const {
    catalog,
    catalogFieldDetails: catalogField,
    updateCatalogError,
    updateCatalogFieldError,
  } = useCatalogContext();

  return useCallback(() => {
    if (option.isNone(catalog)) updateCatalogError();
    else if (option.isNone(catalogField)) updateCatalogFieldError();
  }, [catalog, catalogField]);
};
